export default "__VITE_ASSET__Ysl1vPGU__"